export enum ElementType {
    TEXT = "text",
    IMAGE = "image",
    NUMBER = "number"
}
